import API from "../api/ruesApi";

export const useRues = () => {
  const consultarRues = async (nit) => {
    const res = await API.get(`/ConsultaRUES?numero_identificacion=${nit}`);
    return res.data;
  };

  const obtenerValor = async (nit) => {
    const res = await API.get(
      `/ObtenerValorAfiliado?numero_identificacion=${nit}`,
    );
    return res.data;
  };

  const crearAfiliado = async (data) => {
    const res = await API.post(
      `/CrearAfiliado?numero_identificacion=${data.numero_identificacion}`,
      data,
    );
    return res.data;
  };

  const actualizarAfiliado = async (data) => {
    const res = await API.put(
      `/ActualizarAfiliado?numero_identificacion=${data.numero_identificacion}`,
      data,
    );
    return res.data;
  };

  const eliminarAfiliado = async (nit) => {
    const res = await API.delete(
      `/EliminarAfiliado?numero_identificacion=${nit}`,
    );
    return res.data;
  };

  return {
    consultarRues,
    obtenerValor,
    crearAfiliado,
    actualizarAfiliado,
    eliminarAfiliado,
  };
};
